import { mapSaSwapProducts } from '../../utils';

export const findProduct = (products, sub) => {
  const product = products?.find(
    (product) =>
      product.external_product_id ===
      mapSaSwapProducts(sub.external_product_id.ecommerce),
  );

  return product;
};

export const getVariantsToShow = (product) => {
  const variants = product.variants.filter(
    (variant) =>
      Number(variant?.prices?.[0]?.unit_price) &&
      !variant.title?.toLowerCase()?.includes('device'),
  );

  return variants;
};
